import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import { withTranslation } from 'react-i18next';
import {ChannelLogo} from "../channels/ChannelLogo";

class BusinessUnitHeaderComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: this.props.name,
            status: this.props.status,
            clientId: this.props.clientId,
            clientName: this.props.clientName,
            campaignChannel: this.props.campaignChannel,
            campaignChannelForDisplay: this.props.campaignChannelForDisplay,
        }
    }

    componentDidMount() {
        this.getBusinessUnitData();
    }

    editBusinessUnitUrl() {
        return API_URL + `business-unit/${this.props.businessUnitId}/edit`;
    }

    getBusinessUnitData() {
        if (this.state.name === undefined) {
            new APIClient(this.editBusinessUnitUrl()).call('GET').then((response) => {
                if (response.status === 'ERROR') {
                    alert(response.error_message);
                } else if (response.status === 'OK') {
                    this.setState({
                        name: response.data.name,
                        status: response.data.status,
                        clientId: response.data.client_id,
                        clientName: response.data.client_name,
                        campaignChannel: response.data.campaign_channel,
                        campaignChannelForDisplay: response.data.campaign_channel_for_display,
                    });
                }
            });
        }
    }

    renderStatus() {
        const { t } = this.props;
        if (this.state.status === 'active') {
            return t('business_unit_header.status_active')
        }
        else {
            return t('business_unit_header.status_inactive')
        }
    }

    render() {
        const { t } = this.props;
        const statusIsActive = this.state.status === 'active';
        const statusClass = statusIsActive ? '-active' : '-inactive';

        return (
            <header className="section-header business-unit-header-v2">
                <div className="section-info">
                    <div className="business-unit-heading">
                        <span className="business-unit-heading-kicker">{t('business_unit_header.kicker')}</span>
                        <div className="business-unit-heading-title-row">
                            <Link className="section-title-button" to={`/client/${this.state.clientId}`}>
                                {this.state.clientName}
                            </Link>
                            <span className="business-unit-heading-separator">|</span>
                            <h1 className="section-title">{this.state.name}</h1>
                        </div>
                    </div>
                </div>
                <div className="business-unit-header-meta">
                    <div className="business-unit-header-type">
                        <span>{t('business_unit_header.type')}</span>
                        <strong>
                            <ChannelLogo channel={this.state.campaignChannel} height={18} width={18} hspace={0} vspace={0}/>
                            {this.state.campaignChannelForDisplay}
                        </strong>
                    </div>
                    {this.state.status && (
                        <div className={`business-unit-header-status ${statusClass}`}>
                            {this.renderStatus()}
                        </div>
                    )}
                </div>
            </header>
        )
    }
}

export const BusinessUnitHeader = withTranslation()(BusinessUnitHeaderComponent);
